import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';



import { ApmTranslatePipe } from '@mitsubishi/core';
import { ButtonComponent } from '@mitsubishi/shared/ui';





@Component({
  selector: 'apm-page-not-found',
  imports: [RouterLink, ButtonComponent, ApmTranslatePipe],
  templateUrl: './page-not-found.component.html',
})
export class PageNotFoundComponent {}
